import React, { useEffect, useState } from 'react';
import * as yup from 'yup';
import axios from 'axios';
import { useHistory, useLocation, useParams } from 'react-router';
import { ItemResponse, SaveResponse } from 'helpers/interfaces';


interface IContext {
    isSaving: boolean
    isLoading: boolean
    customer: Customer
    isNew: boolean

    saveCustomer: (ticket: Customer) => Promise<void>
}

export let customerSchema = yup.object({
    id: yup.string().default(''),
    email: yup.string().default("").required(),
    firstName: yup.string().default('').required(),
    typology: yup.string().default("Customer"),
    lastName: yup.string().default('').required(),
    m3Id: yup.string().default(''),
    companyName: yup.string().default(''),
});

type Customer = yup.InferType<typeof customerSchema>;

export let customerContext = React.createContext({} as IContext);

let { Provider } = customerContext;

let CustomerProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    let history = useHistory();
    let { id } = useParams<{ id: string }>();
    let location = useLocation();

    let isNew = location.pathname.includes("/addnew");

    let [isSaving, setSaving] = useState(false);
    
    let [isLoading, setLoading] = useState<boolean>(isNew === false);
    let [customer, setCustomer] = useState(customerSchema.getDefault());


    useEffect(() => {
        if (isNew === false)
            getCustomer();

    }, [id, isNew])

    let getCustomer = async () => {
        try {
            let res = await axios.get<ItemResponse<Customer>>('/api/User/GetUser', { params: { id } });

            let { item } = res.data;
            setCustomer({
                ...item,
                companyName: item.companyName || '',
                m3Id: item.m3Id || '',

            });
            setLoading(false);

        } catch (err) { }
        finally {
            setLoading(false);
        }
    }

    let saveCustomer = async (request: Customer) => {
        try {
            setSaving(true);
            await axios.post<SaveResponse>('/api/User/SaveUser', request);
            history.push('/admin/customers');
        } catch (err) {
            setSaving(false);
        }
    }


    return (
        <Provider
            value={{
                isNew,
                isSaving,
                customer,
                isLoading,
                
                saveCustomer
            }}
        >
            {children}
        </Provider>
    )
}

export default CustomerProvider;